import type { MutationUpdaterFn } from '@apollo/client';

import { updateCache } from 'src/modules/apollo/apolloCache';
import type * as Schema from 'src/types/graphql';

export const updateCacheCreateShareableProfileSettings: MutationUpdaterFn<
  Schema.CreateShareableProfileSettingsMutation
> = (cache, { data }) => {
  if (data && 'viewer' in data.createShareableProfileSettings) {
    const shareableProfileSettings =
      data?.createShareableProfileSettings?.viewer?.shareableProfileSettings;
    if (shareableProfileSettings) {
      updateCache({
        cache,
        data: shareableProfileSettings,
        fieldName: 'shareableProfileSettings',
      });
    }
  }
};

export const updateCacheUpdateProfileVisibility: MutationUpdaterFn<
  Schema.UpdateProfileVisibilityMutation
> = (cache, { data }) => {
  const _id = data?.updateProfileVisibility?.viewer?._id;

  cache.modify({
    id: cache.identify({
      __typename: 'Candidate',
      _id,
    }),
    fields: {
      profileVisibility: () =>
        data?.updateProfileVisibility?.viewer?.profileVisibility || null,
    },
  });
};

export const updateCacheUpdateShareableProfileSettings: MutationUpdaterFn<
  Schema.UpdateShareableProfileSettingsMutation
> = (cache, { data }) => {
  if (data && 'viewer' in data.updateShareableProfileSettings) {
    const shareableProfileSettings =
      data?.updateShareableProfileSettings?.viewer?.shareableProfileSettings;
    if (shareableProfileSettings) {
      updateCache({
        cache,
        data: shareableProfileSettings,
        fieldName: 'shareableProfileSettings',
      });
    }
  }
};
